import ServicePageTemplate from "../components/ServicePageTemplate";
import usePageMeta from "../hooks/usePageMeta";

export default function Snorojning() {
  usePageMeta({
    title: "Snöröjning i Laholm | Trädfällarna Laholm AB",
    description:
      "Snöröjning för fastigheter, gårdar och större ytor i Laholm med omnejd. Trygg framkomlighet under vintern.",
  });

  return (
    <ServicePageTemplate
      eyebrow="Tjänst"
      title="Snöröjning för fastigheter och gårdar"
      intro="Under vintern hjälper vi till att hålla vägar, gårdsytor och andra ytor framkomliga och säkra. En praktisk tjänst för fastigheter, företag och större privata ytor."
      heroImage="/images/card-snorojning.png"
      bodyHeading="Trygg framkomlighet hela vintern"
      bodyText="Vi rycker ut när snön kommer och håller dina ytor öppna och säkra. Vanliga uppdrag är fastighetsgårdar, parkeringar, infarter och privata ytor där det är viktigt att man tar sig fram även när det blåser tungt."
      bullets={[
        "Snöröjning för fastigheter och gårdar",
        "Parkeringar och infarter",
        "Större privata ytor",
        "Snabb utryckning vid behov",
      ]}
    />
  );
}
